import { serverTimestamp, setDoc, updateDoc } from "firebase/firestore";

// Every write to a top-level primary document (timesheet / quote / jobsheet / restore) goes
// through these so modifiedOn is always bumped. The primaries providers only sync documents
// whose modifiedOn is newer than their last sync (see useDeltaSyncedCollection), so a write
// that skips this is never seen by other devices. Job description subcollection writes don't
// need it - nothing outside the primary's own page reads them.
//
// emailLower is kept alongside email so the Gmail Add-on's primariesByEmail lookup can query
// on it instead of scanning every primary (email is stored exactly as typed).
export const withPrimaryMeta = (data = {}) => {
  let meta = { modifiedOn: serverTimestamp() };

  if (typeof data.email === "string") {
    meta.emailLower = data.email.trim().toLowerCase();
  }

  return { ...data, ...meta };
};

export const updatePrimary = (ref, data) => updateDoc(ref, withPrimaryMeta(data));

export const setPrimary = (ref, data, options) =>
  options ? setDoc(ref, withPrimaryMeta(data), options) : setDoc(ref, withPrimaryMeta(data));
